import * as Sentry from '@sentry/react';
import type { BrowserOptions } from '@sentry/react';

type RouterForTracing = Parameters<
  typeof Sentry.tanstackRouterBrowserTracingIntegration
>[0];

export function defaultTracesSampleRate(isProduction: boolean): number {
  return isProduction ? 0.1 : 1;
}

export type InitBrowserSentryOptions = {
  router: RouterForTracing;
  dsn: string;
  enabled: boolean;
  environment: string;
  isProduction?: boolean;
  options?: Omit<BrowserOptions, 'dsn' | 'environment'>;
};

/**
 * Shared Sentry browser init for TanStack Start apps.
 * App-specific concerns (Cookiebot replay, ignore lists, DSN source) stay in the app wrapper.
 */
export function initBrowserSentry({
  router,
  dsn,
  enabled,
  environment,
  isProduction = environment === 'production',
  options = {},
}: InitBrowserSentryOptions): void {
  if (!enabled || !dsn) {
    return;
  }

  const { integrations, tracesSampleRate, ...rest } = options;

  Sentry.init({
    dsn,
    environment,
    tracesSampleRate: tracesSampleRate ?? defaultTracesSampleRate(isProduction),
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      ...(Array.isArray(integrations) ? integrations : []),
    ],
    ...rest,
  });
}
